import React from 'react';
import { connect } from 'react-redux';
import { getAssistantIsOpen } from './store/selectors';
import { toggleAssistantOpen } from './store/actions';
import { getDarkMode } from 'selectors/theme';
import { isLoggedIn } from 'selectors/authentication';
import AssistantPanel from './AssistantPanel';
import './AssistantWidget.css';

function AssistantIcon() {
  return (
    <span className="assistant-widget-icon" aria-hidden>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        width="28"
        height="28"
        fill="currentColor"
        role="img"
        aria-label="AI icon"
      >
        <path
          d="M60 32 H168"
          fill="none"
          stroke="currentColor"
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M224 110 V196 A28 28 0 0 1 196 224 H60 A28 28 0 0 1 32 196 V60 A28 28 0 0 1 60 32"
          fill="none"
          stroke="currentColor"
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M216 28 C216 48 230 62 250 62 C230 62 216 76 216 96 C216 76 202 62 182 62 C202 62 216 48 216 28Z"
          fill="currentColor"
        />
        <path
          d="M186 50 C186 58 192 64 200 64 C192 64 186 70 186 78 C186 70 180 64 172 64 C180 64 186 58 186 50Z"
          fill="currentColor"
        />
        <text
          x="72"
          y="170"
          fontFamily="system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif"
          fontSize="96"
          fontWeight="800"
          fill="currentColor"
        >
          AI
        </text>
      </svg>
    </span>
  );
}

function AssistantWidget({ isOpen, darkMode, onToggle, isLoggedIn }) {
  if (!isLoggedIn) return null;
  return (
    <div className="assistant-widget">
      {isOpen && (
        <div className="assistant-widget-panel-wrapper">
          <AssistantPanel />
        </div>
      )}
      <button
        type="button"
        className={`assistant-widget-toggle ${darkMode ? 'dark-mode' : ''}`}
        onClick={onToggle}
        aria-label={isOpen ? 'Close assistant' : 'Open assistant'}
      >
        <AssistantIcon />
      </button>
    </div>
  );
}

export default connect(
  (state) => ({
    isOpen: getAssistantIsOpen(state),
    darkMode: getDarkMode(state),
    isLoggedIn: isLoggedIn(state),
  }),
  (dispatch) => ({
    onToggle: () => dispatch(toggleAssistantOpen()),
  })
)(AssistantWidget);
